import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OutboundWarehouseManagementView } from "src/components/views/erp/warehouse/outboundWarehouse/OutboundWarehouseManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/project/delivery/outboundWarehouse")({
	staticData: { title: i18n.t("outbound_warehouse"), legacyViewKey: "projectOutboundWarehouseManagementPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <OutboundWarehouseManagementView />;
}
